import { render, staticRenderFns } from "./ChatsSubmenu.vue?vue&type=template&id=64f29970"
import script from "./ChatsSubmenu.vue?vue&type=script&lang=js"
export * from "./ChatsSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports